require("stylesFolderPath/scss/chat.scss");

/** Add moment */

require("../vendors/moment");

/** Add jquery.slimscroll */

require("../vendors/jquery.slimscroll");

/** Add owl.carousel */

require("../vendors/owl.carousel");

/** Add marked */

require("../vendors/marked");

/** Add trunk8 */

require("../vendors/trunk8");

/** Add scripts/ellipsisText.js */

window.EllipsisText = require("scriptsFolderPath/ellipsisText.js");

/** Add scripts/ChatBotUtils.js */

window.ChatBotUtils = require("scriptsFolderPath/ChatBotUtils.js");

/** Add scripts/chatBot.js */

require("scriptsFolderPath/chatBot.js");
